// extracted by mini-css-extract-plugin
module.exports = {"checkbox_checked":"checkbox_checked-2UPNZ","checkbox":"checkbox-2bO8N","terms":"terms-2JrmH"};